/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import s from "./Overlay.module.css";
import { FC, ReactNode, useEffect } from "react";

type IOverlayVarient = "page"

type Props = {
  children: ReactNode
  isOpen?: boolean
  onClick?: Function
  variant?: IOverlayVarient
}

const Overlay: FC<Props> = ({ children, isOpen, onClick, variant = "page" }) => {
  const handleOnClick = () => {
    if (onClick) onClick();
  };
  useEffect(() => {
    if (isOpen) {
      document.body.className = "overflow-hidden sm:pe-4";
    } else {
      document.body.className = "overflow-auto";
    }
  }, [isOpen]);
  return (
    <div
      className={cn(
        s.root,
        variant && s[variant],
        isOpen ? "opacity-100 visible" : "opacity-0 invisible"
      )}
    >
      <div className={s.overlay} onClick={handleOnClick} />
      {children}
    </div>
  );
};

export default Overlay;
